import { Input, Tooltip } from 'antd';

const NumericInput = (props) => {
  const { value, onChange } = props;

  const handleChange = (e) => {
    const { value: inputValue } = e.target;
    const reg = /^-?\d*(\.\d*)?$/;

    if (reg.test(inputValue) || inputValue === '' || inputValue === '-') {
      onChange(inputValue);
    }
  }; // '.' at the end or only '-' in the input box.

  const handleBlur = () => {
    let valueTemp = value;

    if (value.charAt(value.length - 1) === '.' || value === '-') {
      valueTemp = value.slice(0, -1);
    }

    onChange(valueTemp);
  };


  return (
      <Input
        {...props}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="โปรดระบุรหัส OTP"
        maxLength={6}
        className="input-info"
      />
  );
};
export default NumericInput;
